module.exports = __webpack_public_path__ + "static/media/pem.a7bcaf44.png";